export var ExploDashboardType;
(function (ExploDashboardType) {
    ExploDashboardType["PERFORMANCE"] = "PERFORMANCE";
    ExploDashboardType["STOREFRONT_EXPLORER"] = "STOREFRONT_EXPLORER";
})(ExploDashboardType || (ExploDashboardType = {}));
